// components/TeamMemberCard.js
import React, { useState } from "react";

const colors = {
  mainBlue: "#061941",
  cafeNoir: "#583E23",
  carrieban: "#3C6E71",
  isabelline: "#F4F3EE",
  gold: "#F2AF29"
};

export default function TeamMemberCard({ member, isEven, isVisible }) {
  const [isHovered, setIsHovered] = useState(false);

  const handleImageClick = () => {
    if (member.website) {
      window.open(member.website, '_blank');
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "3rem",
        maxWidth: "800px",
        width: "100%",
        flexDirection: isEven ? "row" : "row-reverse",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(30px)",
        transition: "all 0.6s ease-out"
      }}
    >
      {/* Profile Image */}
      <div
        style={{
          width: "250px",
          height: "250px",
          backgroundColor: colors.isabelline,
          border: `3px solid ${colors.gold}`,
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          overflow: "hidden",
          cursor: member.website ? "pointer" : "default",
          transform: isHovered ? "scale(1.05)" : "scale(1)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          boxShadow: isHovered 
            ? `0 8px 25px rgba(0, 0, 0, 0.3), 0 0 0 3px ${colors.gold}40`
            : "0 4px 15px rgba(0, 0, 0, 0.2)"
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleImageClick}
      >
        <img
          src={member.image}
          alt={member.name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.3s ease"
          }}
          onError={(e) => {
            // Fallback if image doesn't load
            e.target.style.display = "none";
            e.target.parentElement.innerHTML = `
              <div style="
                font-size: 1.2rem; 
                color: ${colors.mainBlue}; 
                text-align: center;
                font-weight: 600;
              ">
                ${member.name.split(' ').map(n => n[0]).join('')}
              </div>
            `;
          }}
        />
        
        {/* Hover overlay */}
        {isHovered && member.website && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(6, 25, 65, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: colors.isabelline,
              fontSize: "0.9rem",
              fontWeight: 600,
              opacity: isHovered ? 1 : 0,
              transition: "opacity 0.3s ease"
            }}
          >
            Visit Website
          </div>
        )}
      </div>

      {/* Member Info */}
      <div
        style={{
          flex: 1,
          textAlign: isEven ? "left" : "right",
          transform: isVisible ? "translateX(0)" : `translateX(${isEven ? "-20px" : "20px"})`,
          transition: "transform 0.6s ease-out 0.2s"
        }}
      >
        <h2
          style={{
            fontFamily: "Poppins, Segoe UI, Arial, sans-serif",
            fontSize: "2rem",
            fontWeight: 700,
            color: colors.isabelline,
            margin: "0 0 0.5rem 0"
          }}
        >
          {member.name}
        </h2>
        <p
          style={{
            fontSize: "1.1rem",
            color: colors.gold,
            margin: "0 0 0.5rem 0",
            fontWeight: 600
          }}
        >
          {member.role}
        </p>
        <p
          style={{
            fontSize: "1rem",
            color: colors.isabelline,
            margin: "0 0 0.3rem 0",
            opacity: 0.9
          }}
        >
          {member.school}
        </p>
        <p
          style={{
            fontSize: "0.95rem",
            color: colors.isabelline,
            margin: 0,
            opacity: 0.8
          }}
        >
          {member.major}
        </p>
        

      </div>
    </div>
  );
}